import React from "react";
import { MdEmail, MdPhone } from "react-icons/md";
import { FaGlobe } from "react-icons/fa";
import "../styles/termsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <div className="terms-container theme--2">
      <header className="terms-header">
        <h1>Terms & Conditions</h1>
        <p>Welcome to Matel Trading Motors</p>
      </header>

      <section className="terms-section">
        <h2>1. Introduction</h2>
        <p>
          1.1 This website (<strong>www.mateltradingmotors.com</strong>), related
          mobile sites, and software applications (collectively referred to as
          the “Website”) are owned and operated by{" "}
          <strong>Matel Trading Motors</strong> (“we”, “our”, “us”).
        </p>
        <p>
          1.2 These Terms and Conditions (“Terms”) govern the use of our
          Website, the ordering, sale, and delivery of vehicles and related
          services to customers (“you”, “your”, “user”, “customer”).
        </p>
        <p>
          1.3 Any personal data collected through communication, transactions,
          or inquiries is handled securely for legitimate business purposes only
          — in line with Kenya’s Data Protection Act. For details, see our{" "}
          <a href="/privacy-policy" className="terms-link">
            Data Privacy Policy
          </a>
          .
        </p>
        <p>
          1.4 By accessing or using this Website, you agree to comply with these
          Terms. If you do not agree, please discontinue use of our Website and
          services.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. Waiver</h2>
        <p>
          If Matel Trading Motors fails to enforce any provision of these
          Terms at any given time, it does not mean we have waived our right to
          enforce it later. Any waiver must be made in writing to be valid.
        </p>
      </section>

      <section className="terms-section">
        <h2>3. Severability</h2>
        <p>
          If any provision of these Terms is deemed invalid or unenforceable by
          a competent authority, the remaining provisions shall continue to be
          valid and enforceable.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. Variation</h2>
        <p>
          We reserve the right to update or modify these Terms at any time
          without prior notice. Please review them periodically. Continued use
          of our Website or services constitutes acceptance of any updated
          Terms.
        </p>
      </section>

      <section className="terms-section">
        <h2>5. Accuracy of Information</h2>
        <p>
          While we strive for accuracy, Matel Trading Co., Ltd cannot be held
          liable for typographical errors, omissions, or outdated information.
          Vehicle descriptions, specifications, or pricing are subject to
          change. We will make reasonable efforts to inform customers of
          significant updates.
        </p>
      </section>

      <section className="terms-section">
        <h2>6. Pricing & Availability</h2>
        <p>
          All prices are valid only for vehicles currently in stock. Custom
          orders or special imports may require additional time and costs. We
          will communicate any changes in pricing or availability before
          completing a sale.
        </p>
      </section>

      <section className="terms-section">
        <h2>7. Intellectual Property</h2>
        <p>
          All content, including images, logos, text, videos, and design layouts
          displayed on this website, are the intellectual property of{" "}
          <strong>Matel Trading Motors</strong> or its partners. Any
          unauthorized use or reproduction is strictly prohibited.
        </p>
      </section>

      <section className="terms-section">
        <h2>8. Governing Law</h2>
        <p>
          These Terms and any transactions conducted through our Website are
          governed by the laws of Kenya. Any disputes shall be resolved within
          Kenyan jurisdiction.
        </p>
      </section>

      <section className="terms-section">
        <h2>9. Company Information & Contact</h2>
        <p>
          This website is owned and operated by{" "}
          <strong>Matel Trading Motors</strong>.
        </p>
        <div className="contact-links">
          <p>
            <MdPhone className="contact-icon" />  +254 713 988 888
          </p>
          <p>
            <MdEmail className="contact-icon" />{" "}
            <a href="mailto:mateltradingmotors@gmail.com">
              mateltradingmotors.com
            </a>
          </p>
          <p>
            <FaGlobe className="contact-icon" />{" "}
            <a
              href="https://www.mateltradingmotors.com"
              target="_blank"
              rel="noreferrer"
            >
              www.mateltradingmotors.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
